'use client';

import { ScrollingLogos } from '../animations'

export default function ClientsPartners() {
  const logos = [
    { src: "/images/logos/AALogo.svg", alt: "American Airlines logo", width: 190 },
    { src: "/images/logos/citi.svg", alt: "Citi logo", width: 50 },
    { src: "/images/logos/google-fitbit.svg", alt: "Google Fitbit logo", width: 150 },
    { src: "/images/logos/goodrxlogo.svg", alt: "GoodRx logo", width: 150 },
    { src: "/images/logos/thos.svg", alt: "THE HOUSE OF SUNTORY logo", width: 250 },
    { src: "/images/logos/nttdata.svg", alt: "NTT DATA logo", width: 130 },
    { src: "/images/logos/nyplogo.svg", alt: "NewYork-Presbyterian logo", width: 240 },
  ]

  return (
    <div className="clients-partners">
      <div className="mx-auto overflow-hidden">
        <ScrollingLogos 
          logos={logos}
          duration={30}
          gap={120}
        />
      </div>
    </div>
  )
}